// FULL SIZE

// promo
import promo_band_1 from '../../../assets/img/photos/gallery/full/promo_band_1b.jpg';
import promo_band_2 from '../../../assets/img/photos/gallery/full/promo_band_2.jpg';
import promo_band_3 from '../../../assets/img/photos/gallery/full/promo_band_3.jpg';

// import promo_self_1 from '../../../assets/img/photos/gallery/full/promo_self_1.jpg';
// import promo_self_2 from '../../../assets/img/photos/gallery/full/promo_self_2.jpg';
// import promo_self_3 from '../../../assets/img/photos/gallery/full/promo_self_3.jpg';
// import promo_self_4 from '../../../assets/img/photos/gallery/full/promo_self_4.jpg';
// import promo_self_5 from '../../../assets/img/photos/gallery/full/promo_self_5.jpg';
// import promo_self_6 from '../../../assets/img/photos/gallery/full/promo_self_6.jpg';
// import promo_self_7 from '../../../assets/img/photos/gallery/full/promo_self_7.jpg';

// live
// import live_chamber_1 from '../../../assets/img/photos/gallery/full/live_chamber_1.jpg';
// import live_complex_3 from '../../../assets/img/photos/gallery/full/live_complex_3.jpg';
// import live_chamber_6 from '../../../assets/img/photos/gallery/full/live_chamber_6.jpg';
// import live_chamber_8 from '../../../assets/img/photos/gallery/full/live_chamber_8.jpg';
// import live_complex_1 from '../../../assets/img/photos/gallery/full/live_complex_1.jpg';
// import live_complex_2 from '../../../assets/img/photos/gallery/full/live_complex_2.jpg';


// THUMBNAILS (200px)

// promo
import _promo_band_1 from '../../../assets/img/photos/gallery/thumbs/200/promo_band_1b.jpg';
import _promo_band_2 from '../../../assets/img/photos/gallery/thumbs/200/promo_band_2.jpg';
import _promo_band_3 from '../../../assets/img/photos/gallery/thumbs/200/promo_band_3.jpg';

// import _promo_self_1 from '../../../assets/img/photos/gallery/thumbs/200/promo_self_1.jpg';
// import _promo_self_2 from '../../../assets/img/photos/gallery/thumbs/200/promo_self_2.jpg';
// import _promo_self_3 from '../../../assets/img/photos/gallery/thumbs/200/promo_self_3.jpg';
// import _promo_self_4 from '../../../assets/img/photos/gallery/thumbs/200/promo_self_4.jpg';
// import _promo_self_5 from '../../../assets/img/photos/gallery/thumbs/200/promo_self_5.jpg';
// import _promo_self_6 from '../../../assets/img/photos/gallery/thumbs/200/promo_self_6.jpg';
// import _promo_self_7 from '../../../assets/img/photos/gallery/thumbs/200/promo_self_7.jpg';

// live
// import _live_chamber_1 from '../../../assets/img/photos/gallery/thumbs/200/live_chamber_1.jpg';
// import _live_complex_3 from '../../../assets/img/photos/gallery/thumbs/200/live_complex_3.jpg';
// import _live_chamber_6 from '../../../assets/img/photos/gallery/thumbs/200/live_chamber_6.jpg';
// import _live_chamber_8 from '../../../assets/img/photos/gallery/thumbs/200/live_chamber_8.jpg';
// import _live_complex_1 from '../../../assets/img/photos/gallery/thumbs/200/live_complex_1.jpg';
// import _live_complex_2 from '../../../assets/img/photos/gallery/thumbs/200/live_complex_2.jpg';


const galleryPhotos = [
    {
        id: '_promo_1b',
        src: {
            thumb: _promo_band_1,
            full: promo_band_1
        },
        alt: "Entrzelle promo photo",
        // caption: "digital design by Tomoki Hasayaka",
    },
    {
        id: '_promo_2',
        src: {
            thumb: _promo_band_2,
            full: promo_band_2
        },
        alt: "Entrzelle promo photo",
        // caption: "digital design by Tomoki Hasayaka",
    },
    {
        id: '_promo_3',
        src: {
            thumb: _promo_band_3,
            full: promo_band_3
        },
        alt: "Entrzelle promo photo",
        // caption: "digital design by Tomoki Hasayaka",
    },
]

export default galleryPhotos;